import Photo from './photo';
export default Photo;